import React, { forwardRef, useState, useImperativeHandle, useRef } from 'react';
import cogoToast from 'cogo-toast';
import NumberFormat from 'react-number-format';

const AbonarForm = forwardRef(function AbonarFormRef(props, ref) {
    const {
        numero_registro,
        subfraccionamiento,
        inquilino,
        id_inquilino,
        metodosPago = [],
        loadingInquilinos,
        onSubmit,
        simple = false,
    } = props;

    const [cantidad, setCantidad] = useState(0);
    const formRef = useRef();

    const handleSubmit = (event) => {
        if (event) event.preventDefault();
        const fd = new FormData(formRef.current);
        const data = Object.fromEntries(fd.entries());
        const cantidadNumber = +cantidad;
        const metodoPagoIdNumber = +data.metodosPago;

        if (cantidadNumber === 0) {
            cogoToast.warn("Ingresar cantidad", { position: "bottom-right", hideAfter: 5 });
            return;
        }
        if (metodoPagoIdNumber === 0) {
            cogoToast.warn("Ingresar Metodo de Pago", { position: "bottom-right", hideAfter: 5 });
            return;
        }
        onSubmit({
            id_inquilino,
            monto: cantidadNumber,
            id_metodoPago: metodoPagoIdNumber,
        });
    };

    useImperativeHandle(ref, () => ({
        submit: () => {
            handleSubmit(null);
        }
    }));

    return (
        <form ref={formRef} className="tw-w-full" onSubmit={handleSubmit} autoComplete="off">
            <div className="tw-space-y-4 tw-p-8">
                {!simple && (
                    <>
                        <div className="tw-flex tw-flex-col tw-space-y-1">
                            <label className="tw-text-sm tw-font-medium tw-text-gray-700">Subfraccionamiento</label>
                            <input
                                className="input-user tw-w-full"
                                name="subfraccionamiento"
                                type="text"
                                value={subfraccionamiento}
                                readOnly
                                disabled
                            />
                        </div>
                        <div className="tw-flex tw-flex-col tw-space-y-1">
                            <label className="tw-text-sm tw-font-medium tw-text-gray-700">Vivienda</label>
                            <input
                                className="input-user tw-w-full"
                                name="vivienda"
                                type="text"
                                value={numero_registro}
                                readOnly
                                disabled
                            />
                        </div>
                        <div className="tw-flex tw-flex-col tw-space-y-1">
                            <label className="tw-text-sm tw-font-medium tw-text-gray-700">Residente</label>
                            <input
                                className="input-user tw-w-full"
                                name="inquilino"
                                type="text"
                                value={inquilino}
                                readOnly
                                disabled
                            />
                        </div>
                        <div className="tw-border-t tw-border-gray-200 tw-my-2"></div>
                    </>
                )}

                <div className="tw-flex tw-flex-col tw-space-y-1">
                    <label className="tw-text-sm tw-font-medium tw-text-gray-700">Método de Pago</label>
                    <select
                        className="input-edit-select-full tw-text-left"
                        disabled={loadingInquilinos || !id_inquilino}
                        name="metodosPago"
                        required
                    >
                        <option value={0}>Seleccionar</option>
                        {metodosPago.map((metodo, index) => (
                            <option key={index} value={metodo.Id_FormaPago}>
                                {metodo.Descripcion}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="tw-flex tw-flex-col tw-space-y-1">
                    <label className="tw-text-sm tw-font-medium tw-text-gray-700">Cantidad</label>
                    <NumberFormat
                        className="input-edit tw-bg-gray-100 tw-text-right tw-w-full"
                        displayType="input"
                        name="cantidad"
                        thousandSeparator={true}
                        defaultValue={0}
                        required
                        prefix="$"
                        decimalScale={2}
                        maxLength={10}
                        fixedDecimalScale={true}
                        allowLeadingZeros={false}
                        value={cantidad}
                        disabled={!id_inquilino}
                        onValueChange={({ value }) => setCantidad(value)}
                    />
                </div>
            </div>
        </form>
    );
});

export default AbonarForm;